import { isServerRendering } from "~/lib/ssr/runtime";
import { createFileRoute } from "@tanstack/react-router";
import { warmSymbolShellFromListRoute } from "~/features/symbol/routing/warm-symbol-shell";
import { createPublicBrowseHead } from "~/lib/ssr/public-browse-head";
import { EXPLORE_SOCIAL_METADATA } from "~/lib/social-metadata";

export const Route = createFileRoute("/_app/explore")({
  ssr: true,
  loader: ({ context, preload }) => {
    const warm = import("~/features/explore/explore-route").then((module) =>
      module.preloadExploreRoute(context),
    );
    if (isServerRendering() || preload) return warm;
    void warm;
    warmSymbolShellFromListRoute(preload);
  },
  head: () => createPublicBrowseHead("/explore", EXPLORE_SOCIAL_METADATA),
});
